import React, { useRef, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";

export default function PermissionCard({ branchData, student }) {
  const printRef = useRef();

  const [formData, setFormData] = useState({
    name:
      [student?.firstName, student?.middleName, student?.lastName]
        .filter(Boolean)
        .join(" ") || "",

    course: student?.selectedCourse || "",

    examCourse: "BSc",
    examMonth: "DECEMBER",
    examYear: "2025",

    fromDate: "",
    toDate: "",

    date: new Date().toLocaleDateString("en-GB"),
  });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handlePrint = () => {
    const content = printRef.current.innerHTML;

    const win = window.open("", "", "width=900,height=700");

    win.document.write(`
      <html>
        <head>
          <title>PERMISSION CARD</title>

          <style>
            body {
              font-family: "Times New Roman", serif;
              padding: 40px;
              margin: 0;
            }

            .header {
              width: 100%;
              text-align: center;
              margin-bottom: 20px;
            }

            .logo {
              display: block;
              width: 80px;
              margin: 0 auto 5px auto;
            }

            .title-main,
            .title-sub {
              width: 100%;
              text-align: center;
              font-weight: bold;
            }

            .title-main {
              font-size: 20px;
            }

            .title-sub {
              font-size: 16px;
              margin-bottom: 20px;
            }

            .field-row {
              margin: 20px 0;
              font-size: 15px;
            }

            .label {
              display: inline-block;
              width: 140px;
              font-weight: bold;
            }

            .line {
              display: inline-block;
              border-bottom: 1px dotted #000;
              min-width: 300px;
              padding-left: 5px;
            }

            .footer {
              margin-top: 80px;
            }

            .left {
              float: left;
              font-weight: bold;
            }

            .right {
              float: right;
              font-weight: bold;
            }

            .clear {
              clear: both;
            }
          </style>
        </head>

        <body>
          ${content}
        </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <Container className="mt-4">

      {/* PRINT AREA */}
      <div ref={printRef}>

        <div className="header">

          {branchData?.logoUrl && (
            <img
              src={branchData.logoUrl}
              alt="Logo"
              className="logo"
              style={{ width: "80px" }}
            />
          )}

          <div className="title-main">
            REHOBOTH INSTITUTE OF NURSING
          </div>

          <div className="title-sub">
            PERMISSION CARD FOR{" "}
            {formData.examCourse} {formData.examMonth}{" "}
            {formData.examYear} EXAMINATION
          </div>

        </div>

        <div className="field-row">
          <span className="label">NAME</span> :
          <span className="line">{formData.name}</span>
        </div>

        <div className="field-row">
          <span className="label">COURSE</span> :
          <span className="line">{formData.course}</span>
        </div>

        <div className="field-row">
          <span className="label">FROM</span> :
          <span className="line">{formData.fromDate}</span>

          <span style={{ marginLeft: "20px", fontWeight: "bold" }}>
            TO :
          </span>

          <span className="line" style={{ marginLeft: "10px" }}>
            {formData.toDate}
          </span>
        </div>

        <div className="footer">

          <div style={{ marginBottom: "50px" }}>
            Date : {formData.date}
          </div>

          <div className="left">
            ADMIN
          </div>

          <div className="right">
            PRINCIPAL
          </div>

          <div className="clear"></div>

        </div>

      </div>

      {/* FORM */}
      <Form className="mt-4">

        <Row className="mb-2">
          <Col>
            <Form.Control
              placeholder="Name"
              value={formData.name}
              onChange={(e) =>
                handleChange("name", e.target.value)
              }
            />
          </Col>

          <Col>
            <Form.Control
              placeholder="Course"
              value={formData.course}
              onChange={(e) =>
                handleChange("course", e.target.value)
              }
            />
          </Col>
        </Row>

        <Row className="mb-2">

          <Col>
            <Form.Control
              placeholder="Exam Course"
              value={formData.examCourse}
              onChange={(e) =>
                handleChange("examCourse", e.target.value)
              }
            />
          </Col>

          <Col>
            <Form.Control
              placeholder="Month"
              value={formData.examMonth}
              onChange={(e) =>
                handleChange(
                  "examMonth",
                  e.target.value.toUpperCase()
                )
              }
            />
          </Col>

          <Col>
            <Form.Control
              placeholder="Year"
              value={formData.examYear}
              onChange={(e) =>
                handleChange("examYear", e.target.value)
              }
            />
          </Col>

        </Row>

        <Row className="mb-2">

          <Col>
            <Form.Control
              type="date"
              onChange={(e) => {
                const value = e.target.value;

                if (value) {
                  handleChange(
                    "fromDate",
                    new Date(value).toLocaleDateString("en-GB")
                  );
                }
              }}
            />
          </Col>

          <Col>
            <Form.Control
              type="date"
              onChange={(e) => {
                const value = e.target.value;

                if (value) {
                  handleChange(
                    "toDate",
                    new Date(value).toLocaleDateString("en-GB")
                  );
                }
              }}
            />
          </Col>

        </Row>

        <Row className="mb-2">

          <Col>
            <Form.Control
              type="date"
              onChange={(e) => {
                const value = e.target.value;

                if (value) {
                  handleChange(
                    "date",
                    new Date(value).toLocaleDateString("en-GB")
                  );
                }
              }}
            />
          </Col>

        </Row>

        <Button onClick={handlePrint} className="mt-3">
          Print
        </Button>

      </Form>

    </Container>
  );
}